const numberOfEmployees = [
  { label: 'Just you', value: 'Just you' },
  { label: '2-9', value: '2-9' },
  { label: '10-49', value: '10-49' },
  { label: '50-100', value: '50-100' },
  { label: '100+', value: '100+' }
];

export default numberOfEmployees;
